import { Col } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { DateType } from 'api/models';
import { Project } from 'api/project';
import { Field, FieldWithValue } from 'api/tasks';
import {
  Content,
  FieldLabel,
  GhostFields,
  LabelContainer,
  Row,
} from 'components/organisms/task-pane/task-detail/task-fields/styled';
import { getDefaultProjectFieldRenderer } from './utils';

const StyledGhostFields = styled(GhostFields)`
  margin-top: var(--spacing-04);
`;

type Renderer = React.FunctionComponent<any> | null;

export const ProjectDefaultFields: FC<{
  defaultFields: Field[];
  projectData: Project;
  isDefaultFieldsReadOnly: boolean;
  onCustomFieldChange(fieldValue: unknown, { fieldId }: FieldWithValue): void;
  onDefaultFieldChange({
    startDate,
    dueDate,
    annualizedRecurringRevenue,
    projectFee,
  }: {
    startDate?: DateType;
    dueDate?: DateType;
    annualizedRecurringRevenue?: number;
    projectFee?: number;
  }): void;
}> = ({
  defaultFields,
  projectData,
  isDefaultFieldsReadOnly,
  onCustomFieldChange,
  onDefaultFieldChange,
}) => {
  return (
    <StyledGhostFields>
      {defaultFields
        .map((field): [FieldWithValue, Renderer] => [
          field,
          getDefaultProjectFieldRenderer(field),
        ])
        .map(([field, FieldRenderer]) => (
          <Row>
            <Col span={8}>
              <LabelContainer>
                <FieldLabel>{field.fieldLabel}</FieldLabel>
              </LabelContainer>
            </Col>
            <Col span={16}>
              <Content>
                {FieldRenderer ? (
                  <FieldRenderer
                    isReadOnly={isDefaultFieldsReadOnly}
                    field={field}
                    values={projectData.fields}
                    onDefaultFieldChange={onDefaultFieldChange}
                    onCustomFieldChange={onCustomFieldChange}
                    projectData={projectData}
                  />
                ) : null}
              </Content>
            </Col>
          </Row>
        ))}
    </StyledGhostFields>
  );
};
